<template>
  <b-row>
    <b-card-group class="mb-4 col-md-6">
      <b-card>
        <div class="h1 text-muted text-right mb-4">
          <span
            v-if="port.ratio_updated"
            v-b-popover.hover.top="formatDateTime(port.ratio_updated)"
            title="Última actualización"
          >
            <i class="icon-pie-chart"></i>
          </span>
        </div>
        <div class="h4 mb-0">{{port.ratio}}</div>
        <small class="text-muted text-uppercase font-weight-bold">Ratio {{port.code}}</small>
      </b-card>
    </b-card-group>
    <b-card-group class="mb-4 col-md-6">
      <b-card>
        <div class="h1 text-muted text-right mb-4">
          <span
            v-if="port.cycle_time_updated"
            v-b-popover.hover.top="formatDateTime(port.cycle_time_updated)"
            title="Última actualización"
          >
            <i class="icon-clock"></i>
          </span>
        </div>
        <div class="h4 mb-0">{{port.format_cycle_time}}</div>
        <small
          class="text-muted text-uppercase font-weight-bold"
        >Tiempo promedio de ciclo {{port.code}}</small>
      </b-card>
    </b-card-group>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import moment from "moment";

export default {
  props: ["port"],
  data() {
    return {
      ports: []
    };
  },
  computed: {
    filteredPorts() {
      return this.ports;
    }
  },
  methods: {
    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    }
  }
};
</script>

